export function promoDiscountBuilderUI(res) {
  return {
    ...res
  };
}
